import { useEffect } from "react";
import styles from "../styles/SearchBar.scss";

export const useMobileStyleBody = (showMobileStyle) => {
  useEffect(() => {
    if (showMobileStyle) {
      const preventScroll = (e) => {
        const target = e.target;
        const mobileContainer = target && target.closest && target.closest(`.${styles.mobile}`);
        if (!mobileContainer) {
          e.preventDefault();
        }
      };

      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${window.scrollY}px`;
      document.addEventListener('touchmove', preventScroll, { passive: false });

      return () => {
        const scrollY = document.body.style.top;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        document.removeEventListener('touchmove', preventScroll);
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      };
    }
  }, [showMobileStyle]);

}


// WEBPACK FOOTER //
// ./src/containers/HomePage/hooks/useMobileStyleBody.ts